<template>
    <VCol class="pb-0 pt-2" cols="12" sm="3">
        <SrInput
            v-if="config.type === 'text'"
            :value="value"
            :label="config.label"
            :hint="config.hint"
            :placeholder="config.placeholder"
            clearable
            @input="emitInput"
        />

        <!-- need to emit input, due to vue reactivity specs -->
        <SrSelect
            v-if="config.type === 'select'"
            :value="value"
            :items="config.items"
            :label="config.label"
            clearable
            attach
            @change="emitInput"
        />

        <SrDatePicker v-if="config.type === 'date'" :value="value" multiple clearable @input="emitInput" />
    </VCol>
</template>

<script>
import { SrInput } from '../SrInput';
import { SrSelect } from '../SrSelect';
import { SrDatePicker } from '../SrDatePicker';
import PropagateInputEvent from '../../mixins/PropagateInputEvent';

export default {
    name: 'SrFilterItem',
    components: {
        SrDatePicker,
        SrSelect,
        SrInput,
    },
    mixins: [PropagateInputEvent],
    model: {
        prop: 'value',
        event: 'input',
    },
    props: {
        value: {
            type: null,
            default: '',
        },
        config: {
            type: Object,
            required: true,
        },
    },
};
</script>
